
<script>
import { productService,orderService } from "../../services";
import vue2Dropzone from "vue2-dropzone";
import { bannerService } from "../../services";
import { required,requiredIf } from "vuelidate/lib/validators";
import config from "../../config";
import { error_message, success_message } from "../../Helper/helper";
import DropzonePopup from "../../components/widgets/dropzone-popup";
import Multiselect from "vue-multiselect";
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
// import AddBanner from "./add-banner";

export default {
  components: { productService,orderService,Multiselect,vueDropzone: vue2Dropzone, DropzonePopup,Layout, PageHeader },
  data() {
    return {
      value: null,
      tmpBannerImage: "",
      url: null,
      config: config,
      search: "",
      errors: "",
      isLoading: false,
      products: [],
      subProducts: [],
      categories: [],
      isDisabled:false,
      bannerTypes: ['Product','Sub Category','Sub Product'],
      typeform: {
        name: "",
        image: null,
        product:"",
        sub_product:"",
        category:"",
        status: true,
        banner_type: '',
      },
    };
  },
  validations: {
    typeform: {
      name: {
        required,
      },
      image: {
        required,
      },
      product: {
        required : requiredIf(function(form){
            return this.typeform.banner_type === 'Product' || this.typeform.banner_type === 'Sub Product';
        }),
      },
      sub_product: {
        required : requiredIf(function(form){
            return this.typeform.banner_type === 'Sub Product';
        }),
      },
      category: {
        required: requiredIf(function (form) {
          return (
            this.typeform.banner_type === 'Sub Category'
          );
        }),
      }
    },
  },
  mounted() {
    // this.getProducts();
  },
  methods: {
    customLabel ({ sub_product_name, material }) {
      if(sub_product_name == "" || sub_product_name == 'undefined') return false;
      return `${sub_product_name} ( ${material} )`
    },
    onFileChange(e) {
      const file = e.target.files[0];
      this.url = URL.createObjectURL(file);
      this.typeform.image = file;
    },
    asyncFindProduct(query) {
      this.isLoading = true;
      productService
        .getSearchProduct({ query, id: "", type: "add" })
        .then((response) => {
          // this.products = response.data.result;
          this.products = response.data.result.sort((a, b) => {
            return a.item_name.localeCompare(b.item_name);
          });
          this.isLoading = false;
        });
    },
    getSubProduct(product) {
      var product_id = product.id;
      if(this.typeform.banner_type == 'Product'){
        return false;
      }
      this.subProducts = [];
      this.typeform.sub_product = "";
      // this.typeform.sub_product = {id:"",sub_product_name:"",material:""};
      this.isLoading = true;
      orderService
        .getVariantByProduct({ product_id:product_id,customer_type: "Private"})
        .then((response) => {
          // this.subProducts = response.data.result;
          this.subProducts = response.data.result.sort((a, b) => {
            return a.sub_product_name.localeCompare(b.sub_product_name);
          });
          this.isLoading = false;
        });

    },
    asyncFindCategory(query) {
      this.isLoading = true;
      productService
        .getSearchSubCategory({'search':query})
        .then((response) => {
          // this.categories = response.data.result;
          // console.log(response.data.result);
          this.categories = response.data.result.sort((a, b) => {
              return a.menu_name.localeCompare(b.menu_name);
          });
          this.isLoading = false;
        });
    },
    bannerInIt() {
      this.$v.$touch();
      if (this.$v.typeform.$invalid) {
       
        setTimeout(()=>{
            $('html, body').animate({
                scrollTop: $(".is-invalid:first").offset().top-$('#page-topbar').height()-50
            }, 200, function() {
                $(".is-invalid:first").focus();
            });
        },500);
        return;
      } else {
        this.isDisabled = true;
        const fd = new FormData();

        fd.append("image", this.typeform.image);
        fd.append("name", this.typeform.name);
        fd.append("product_id", this.typeform.product.id ?? '');
        fd.append("sub_product_id", this.typeform.sub_product.id ?? '');
        fd.append("category_id", this.typeform.category.id ?? '');
        fd.append("status", this.typeform.status ? 1 : 0);
        fd.append("banner_type", this.typeform.banner_type);
        bannerService.addBanner(fd).then((response) => {
          if (response.data.code === 200) {
            success_message(response.data.message);
            this.$router.push({ name: "banner-list" });
          } else {
            error_message(response.data.message);
          }
          this.isDisabled = false;
        });
      }
    },
  },
};
</script>

<template>
  <Layout>
    <div class="row">
      <div class="col-12">
        <div
          class="page-title-box d-flex align-items-center justify-content-between icon-main-page"
        >
          <div class="page-title-left avatar-main-icon">
            <div class="avatar-xs mr-3">
              <span class="avatar-title rounded-circle bg-soft-primary text-primary font-size-18">
                <i class="bx bx-purchase-tag"></i>
              </span>
            </div>
            <div class="report-tag">
              <h4 class="mb-0 font-size-18">{{ trans.get('__JSON__.Add Banner') }}</h4>
              <p><router-link :to="{ name: 'banner-list'}">{{ trans.get('__JSON__.Banners') }}</router-link> > {{ trans.get('__JSON__.Add Banner') }}</p>
          </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <b-form @submit.prevent="bannerInIt">
          <!-- Banner Info Start -->
          <div class="card">
            <div class="card-body">
              <h4 class="card-title">{{ trans.get('__JSON__.Banner Info') }}</h4>
              <p class="card-title-desc"></p>
              <div class="row">
                <div class="col-sm-6">
                  <b-form-group id="input-group-1" :label="trans.get('__JSON__.Name')" label-for="name" label-class="required">
                    <b-form-input
                      id="name"
                      name="name"
                      v-model="$v.typeform.name.$model"
                      type="text"
                      :placeholder="trans.get('__JSON__.Banner Name Placeholder')"
                      :class="{ 'is-invalid':  $v.typeform.name.$error }"
                    ></b-form-input>
                    <div v-if=" $v.typeform.name.$error" class="invalid-feedback">
                      <span
                        v-if="!$v.typeform.name.required"
                      >{{ trans.get('__JSON__.Banner Name Error') }}.</span>
                    </div>
                  </b-form-group>
                </div>

                <div class="col-sm-6">
                  <div class="form-group">
                    <label class="control-label">{{
                      trans.get("__JSON__.Banner Connect With")
                    }}</label>
                    <multiselect 
                      v-model="typeform.banner_type" 
                      :options="bannerTypes" 
                      :searchable="false" 
                      :close-on-select="true" 
                      :show-labels="false" 
                      placeholder="Select option">
                    </multiselect>
                  </div>
                </div>

                <div class="col-sm-6" v-if="this.typeform.banner_type == 'Product' || this.typeform.banner_type == 'Sub Product'">
                  <div class="form-group">
                    <label class="required">{{ trans.trans("__JSON__.Product") }}</label>
                    <multiselect
                      v-model="$v.typeform.product.$model"
                      id="product"
                      label="item_name"
                      track-by="id"
                      :placeholder="trans.get('__JSON__.Type to Search Product')"
                      open-direction="bottom"
                      :options="products"
                      :multiple="false"
                      :searchable="true"
                      :loading="isLoading"
                      :internal-search="true"
                      :close-on-select="true"
                      :clear-on-select="true"
                      :max-height="600"
                      :show-no-results="true"
                      :hide-selected="true"
                      :class="{ 'is-invalid': $v.typeform.product.$error }"
                      @search-change="asyncFindProduct"
                      @select="getSubProduct"
                      >
                      <span
                      slot="noResult"
                      >{{ trans.get('__JSON__.Oops! No elements found. Consider changing the search query') }}.</span>
                    </multiselect>
                    <div v-if="$v.typeform.product.$error" class="invalid-feedback">
                      <span v-if="!$v.typeform.product.required">{{
                        trans.get("__JSON__.Please select product name")
                      }}</span>
                    </div>
                  </div>
                </div>

                <div class="col-sm-6" v-if="this.typeform.banner_type == 'Sub Product'">
                  <div class="form-group">
                    <label class="required">{{ trans.trans("__JSON__.Sub Product") }}</label>
                    <multiselect
                      v-model="$v.typeform.sub_product.$model"
                      id="sub_product"
                      label="sub_product_name"
                      track-by="id"
                      :placeholder="trans.get('__JSON__.Sub Product')"
                      open-direction="bottom"
                      :options="subProducts"
                      :multiple="false"
                      :searchable="false"
                      :loading="isLoading"
                      :internal-search="false"
                      :close-on-select="true"
                      :clear-on-select="true"
                      :max-height="600"
                      :show-no-results="true"
                      :hide-selected="true"
                      :custom-label="customLabel"
                      :class="{ 'is-invalid': $v.typeform.sub_product.$error }"
                      >
                      <span
                      slot="noResult"
                      >{{ trans.get('__JSON__.Oops! No elements found. Consider changing the search query') }}.</span>
                    </multiselect>
                    <div v-if="$v.typeform.sub_product.$error" class="invalid-feedback">
                      <span v-if="!$v.typeform.sub_product.required">{{
                        trans.get("__JSON__.Please select SubProduct")
                      }}</span>
                    </div>
                  </div>
                </div>

                <div class="col-sm-6" v-if="this.typeform.banner_type == 'Sub Category'">
                  <div class="form-group">
                    <label class="required">{{ trans.trans("__JSON__.Sub Category") }}</label>
                    <multiselect
                      v-model="$v.typeform.category.$model"
                      id="category"
                      label="menu_name"
                      track-by="id"
                      :placeholder="trans.get('__JSON__.Sub Category')"
                      open-direction="bottom"
                      :options="categories"
                      :multiple="false"
                      :searchable="true"
                      :loading="isLoading"
                      :internal-search="true"
                      :close-on-select="true"
                      :clear-on-select="true"
                      :max-height="600"
                      :show-no-results="true"
                      :hide-selected="true"
                      :class="{ 'is-invalid': $v.typeform.category.$error }"
                      @search-change="asyncFindCategory"
                      >
                      <span
                      slot="noResult"
                      >{{ trans.get('__JSON__.Oops! No elements found. Consider changing the search query') }}.</span>
                    </multiselect>
                    <div v-if="$v.typeform.category.$error" class="invalid-feedback">
                      <span v-if="!$v.typeform.category.required">{{
                        trans.get("__JSON__.Select Sub Category")
                      }}</span>
                    </div>
                  </div>
                </div>

                <div class="col-sm-6 vendor-status">
                  <b-form-group
                    id="input-group-1"
                    :label="trans.get('__JSON__.Status')"
                    label-for="status"
                  >
                    <label class="switch">
                      <input
                        type="checkbox"
                        id="togBtn"
                        class="switch-on"
                        checked
                        v-model="typeform.status"
                      />
                      <div class="slider round">
                        <span class="on">{{ trans.get('__JSON__.Active') }}</span>
                        <span class="off">{{ trans.get('__JSON__.Inactive') }}</span>
                      </div>
                    </label>
                  </b-form-group>
                </div>
              </div>
            </div>
          </div>
          <!-- Banner Info End -->

          <!-- Banner Image Start -->
          <div class="card">
            <div class="card-body">
              <h4 class="card-title required">{{ trans.get('__JSON__.Banner Image') }}</h4>
              <p class="card-title-desc"></p>

              <div class="row">
                <div class="col-sm-3">
                  <dropzone-popup
                    v-model="typeform.image"
                    type="file"
                    id="banner_image"
                    name="image"
                    acceptedFiles=".jpeg,.jpg,.png"
                    :class="{ 'is-invalid': $v.typeform.image.$error }"
                  />
                  <div v-if="$v.typeform.image.$error" class="invalid-feedback cuisine-img">
                    <span
                      v-if="!$v.typeform.image.required"
                    >{{ trans.get('__JSON__.Banner Image Error') }}.</span>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-sm-6">
                  <button class="btn btn-primary mr-1 mt-3" :disabled="isDisabled">{{ trans.get('__JSON__.Add Banner') }}</button>
                  <!-- <b-button @click="$router.go(-1)" type="button" variant="secondary" class="mt-3">{{ trans.get('__JSON__.Cancel') }}</b-button> -->
                  <router-link
                    :to="{name:'banner-list'}"
                  >
                    <b-button
                      type="button" 
                      variant="secondary" 
                      class="mt-3">
                      {{ trans.get('__JSON__.Cancel') }}
                    </b-button>
                  </router-link>                    
                </div>
              </div>
            </div>
          </div>
          <!-- Banner Image End -->
        </b-form>
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>

<style>
</style>